import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaExternalLinkAlt, FaExpand, FaTimes } from "react-icons/fa";

const Projects = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const myProjects = [
    { id: 1, title: "Stone Aura", url: "https://stone-aura.web.app/", tag: "Interior" },
    { id: 2, title: "My Bindle", url: "https://codershahzad.github.io/Mybindle/", tag: "Portfolio" },
    { id: 3, title: "Community Forum", url: "https://codershahzad.github.io/Community-forum-react.js/", tag: "Social App" },
    { id: 4, title: "Edumingle", url: "https://codershahzad.github.io/Edumingle/", tag: "Education" },
    { id: 5, title: "Portfolio", url: "https://demo-portfolio-in.vercel.app/", tag: "Portfolio" },
  ];

  return (
    <div className="min-h-screen bg-[#f8f9fa] px-6 py-20 md:px-16">
      
      {/* --- HEADER --- */}
      <div className="max-w-7xl mx-auto mb-16 text-center">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-5xl md:text-7xl font-[1000] uppercase tracking-tighter text-slate-900"
        >
          Live <span className="text-transparent bg-clip-text bg-gradient-to-r from-olive-700 to-mehroon-900">Showcase.</span>
        </motion.h2>
      </div>

      {/* --- LIVE CARDS GRID --- */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
        {myProjects.map((project) => (
          <motion.div
            key={project.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="group bg-white rounded-[3rem] p-5 shadow-2xl shadow-slate-200 border border-slate-100 flex flex-col h-[450px]"
          >
            {/* --- MINI LIVE VIEW (CHOTA VIEW) --- */}
            <div className="relative flex-1 w-full rounded-[2.2rem] overflow-hidden bg-slate-200 border border-slate-200">
              
              {/* Iframe Scaled Down to fit in card */}
              <div className="absolute inset-0 origin-top-left w-[400%] h-[400%] scale-[0.25] pointer-events-none">
                <iframe 
                  src={project.url} 
                  title={project.title} 
                  className="w-full h-full border-none"
                  loading="lazy"
                />
              </div>

              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-all duration-300 backdrop-blur-[2px] flex items-center justify-center gap-5">
                <motion.button 
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() => setSelectedProject(project)}
                  className="p-5 bg-white text-mehroon-900 rounded-2xl shadow-xl font-bold flex items-center gap-2"
                >
                  <FaExpand /> Full View
                </motion.button>
              </div>

              {/* Badge */}
              <div className="absolute top-4 left-4 z-10 px-4 py-1.5 bg-white/90 backdrop-blur-md rounded-full text-[10px] font-black uppercase tracking-widest text-mehroon-900 shadow-sm">
                Live Preview
              </div>
            </div>

            {/* --- DETAILS --- */}
            <div className="pt-6 pb-2 px-4 flex justify-between items-end">
              <div>
                <span className="text-olive-700 text-[10px] font-black uppercase tracking-widest">{project.tag}</span>
                <h3 className="text-3xl font-[1000] text-slate-800 tracking-tighter uppercase">{project.title}</h3>
              </div>
              <a 
                href={project.url} 
                target="_blank" 
                rel="noreferrer"
                className="w-12 h-12 rounded-2xl bg-slate-100 flex items-center justify-center text-slate-600 hover:bg-mehroon-800 hover:text-white transition-all"
              >
                <FaExternalLinkAlt size={18} />
              </a>
            </div>
          </motion.div>
        ))}
      </div>

      {/* --- FULL SCREEN VIEW MODAL --- */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[2000] bg-black/95 backdrop-blur-2xl flex flex-col"
          >
            <div className="flex items-center justify-between p-6 bg-white/5 border-b border-white/10">
              <h2 className="text-white font-black uppercase tracking-widest">{selectedProject.title}</h2>
              <button 
                onClick={() => setSelectedProject(null)}
                className="w-12 h-12 bg-mehroon-800 text-white rounded-xl flex items-center justify-center hover:scale-110 transition-transform"
              >
                <FaTimes size={24} />
              </button>
            </div>
            <div className="flex-1 p-4 md:p-10">
              <motion.div 
                initial={{ y: 50, scale: 0.9 }}
                animate={{ y: 0, scale: 1 }}
                className="w-full h-full bg-white rounded-[2rem] overflow-hidden shadow-[0_0_50px_rgba(0,0,0,0.5)]"
              >
                <iframe 
                  src={selectedProject.url} 
                  title={selectedProject.title} 
                  className="w-full h-full border-none"
                />
              </motion.div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Projects;